<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      :header="
        expenditureId == null
          ? 'Adicionar Despesa'
          : inApprove == true
          ? `Aprovar Despesa | ${user.username}`
          : editable == true
          ? 'Editar Despesa'
          : 'Ver Despesa'
      "
      :modal="true"
      :closable="false"
    >
      <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <Message
        severity="error"
        v-if="
          expenditureId &&
          expenditureModel.rejectReason &&
          expenditureModel.rejectReason != '' &&
          inApprove == false
        "
        :closable="false"
        ><b>Despesa Rejeitada: </b> {{ expenditureModel.rejectReason }}</Message
      >
      <form
        name="ExpenditureForm"
        class="p-col-12"
        @submit.prevent="save"
        style="min-height: 60vh"
      >
        <div class="p-fluid p-formgrid p-grid" style="min-height: 20vh">
          <div class="p-field p-col-12 p-md-3">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-calendar"></i>
              </span>
              <span class="p-float-label">
                <v-date-picker
                  v-model="expenditureModel.date"
                  :name="'date-picker'"
                  :id="'date-picker'"
                  v-validate="'required'"
                  :max-date="new Date()"
                  :masks="{
                    input: 'YYYY-MM-DD',
                  }"
                  @input="dateChanged"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        :name="'date'"
                        :id="'date'"
                        :disabled="editable == false || inApprove == true"
                        v-bind:class="[
                          {
                            'p-error': errors.has('date'),
                          },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        v-on="
                          editable == true && inApprove == false
                            ? inputEvents
                            : ''
                        "
                        v-validate="'required'"
                      />
                      <label for="date">Data da Despesa</label>
                    </span>
                  </template>
                </v-date-picker>
              </span>
            </div>
            <small
              v-if="errors.has('date')"
              class="p-error p-ml-5"
              role="alert"
            >
              Data é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-9"
            v-if="expenditureModel.date"
          >
            <InputText
              v-if="editable == false"
              type="text"
              v-model="expenditureModel.patName"
              :disabled="true"
            />
            <AppAutocomplete
              v-else
              label="PAT"
              v-model="expenditureModel.pat"
              :edit-model="expenditureModel"
              :fetchFunction="fetchPats"
              fieldId="pat-select"
              :optionLabel="patOptionLabel"
              v-validate.disable="'required'"
              data-vv-name="pat-select"
              :disabled="!expenditureModel.date"
              :loadOnMount="true"
              @error="handlePatFetchError"
              @change="handlePatChange"
            >
              <template #option="{ option }">
                <span v-if="$isMobile()" class="options-search-responsive">
                  {{ option.id }} | {{ option.client_name }}
                </span>
                <span v-else>
                  {{ option.id }} | {{ option.client_name }}
                </span>
              </template>
            </AppAutocomplete>
            <small v-if="errors.has('pat-select')" class="p-error" role="alert">
              Pat é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="expenditureModel.pat || inApprove == true"
          >
            <span class="p-float-label">
              <Dropdown
                :disabled="editable == false"
                :name="'type'"
                :id="'type'"
                v-model="expenditureModel.type_id"
                :options="types"
                :optionLabel="'name'"
                :optionValue="'reference'"
                :dataKey="'reference'"
                v-validate="'required'"
                @change="typeChanged"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('type'),
                  },
                  'form-control',
                ]"
              />
              <label for="pats">Tipo</label>
            </span>
            <small v-if="errors.has('type')" class="p-error" role="alert">
              Tipo é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="
              expenditureModel.pat ||
              inApprove == true
            "
          >
            <span class="p-float-label">
              <InputText
                :disabled="editable == false"
                :id="'document_reference'"
                :name="'document_reference'"
                type="text"
                v-model="expenditureModel.document_reference"
                v-validate="'required'"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('document_reference'),
                  },
                  'form-control',
                ]"
              />
              <label for="pats">N.º Documento</label>
            </span>
            <small
              v-if="errors.has('document_reference')"
              class="p-error"
              role="alert"
            >
              N.º Documento é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="
              expenditureModel.pat ||
              inApprove == true
            "
          >
            <span class="p-float-label">
              <InputNumber
                :disabled="editable == false"
                type="text"
                v-model="expenditureModel.value"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                v-validate="'required'"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('value'),
                  },
                  'form-control',
                ]"
                :id="'value'"
                :name="'value'"
              />
              <label for="pats">Valor da Despesa</label>
            </span>
            <small v-if="errors.has('value')" class="p-error" role="alert">
              Valor da Despesa é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="
              expenditureModel.pat ||
              inApprove == true
            "
          >
            <span class="p-float-label">
              <InputNumber
                :disabled="editable == false"
                type="text"
                v-model="expenditureModel.value_pay"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                v-validate="'required|max_value:' + expenditureModel.value"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('value_pay'),
                  },
                  'form-control',
                ]"
                :id="'value_pay'"
                :name="'value_pay'"
              />
              <label for="pats">Valor a Pagar</label>
            </span>
            <small v-if="errors.has('value_pay')" class="p-error" role="alert">
              Valor a Pagar é obrigatório. E tem que ser menor ou igual que o
              valor da despesa
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="
              (expenditureModel.pat ||
                inApprove == true) &&
              expenditureModel.type_id != undefined &&
              Object.values(typesConditions).includes(expenditureModel.type_id)
            "
          >
            <span class="p-float-label">
              <InputMask
                v-if="
                  editable == false ||
                  expenditureModel.date < new Date('2023-12-01')
                "
                name="car_registration"
                id="car_registration"
                v-model="expenditureModel.car_registration"
                :disabled="editable == false"
                mask="**-**-**"
                class="p-column-filter"
                v-validate="carRegistrationRequired()"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('car_registration'),
                  },
                  'form-control',
                ]"
              />
              <Dropdown
                v-else
                id="car_registration"
                inputId="car_registration"
                name="car_registration"
                v-model="expenditureModel.car_registration"
                v-validate="carRegistrationRequired()"
                v-bind:class="[
                  { 'p-invalid': errors.has('car_registration') },
                  'form-control',
                ]"
                :showClear="true"
                :options="vehicles"
                :optionLabel="
                  (info) =>
                    info.registration == '00-00-00'
                      ? info.model
                      : info.registration
                "
                :optionValue="'registration'"
                :dataKey="'id'"
                :filter="true"
              >
                <template #option="slotProps">
                  <span v-if="slotProps.option.registration != '00-00-00'"
                    >{{ slotProps.option.registration }} |
                  </span>
                  {{ slotProps.option.model }}
                </template>
              </Dropdown>
              <label for="pats">Matrícula</label>
            </span>
            <small
              v-if="errors.has('car_registration')"
              class="p-error"
              role="alert"
            >
              Matrícula é obrigatório
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-3 p-mt-3"
            v-show="
              (expenditureModel.pat ||
                inApprove == true) &&
              expenditureModel.type_id != undefined &&
              expenditureModel.type_id.indexOf(typesConditions.combustivel) != -1
            "
          >
            <span class="p-float-label">
              <InputNumber
                :disabled="editable == false"
                v-model="expenditureModel.car_km"
                v-validate="carKmRequired()"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('car_km'),
                  },
                  'form-control',
                ]"
                :id="'car_km'"
                :name="'car_km'"
              />
              <label for="pats">Km</label>
            </span>
            <small v-if="errors.has('car_km')" class="p-error" role="alert">
              Km é obrigatório
            </small>
          </div>
          <div></div>
          <div
            class="p-field p-col-12 p-md-6 p-mt-3"
            v-show="
              expenditureModel.pat ||
              inApprove == true
            "
          >
            <span class="p-float-label">
              <InputText
                :disabled="editable == false"
                type="text"
                v-model="expenditureModel.comments"
              />
              <label for="pats">Observações</label>
            </span>
          </div>

          <div class="p-field p-grid p-col-12" v-if="inApprove == true">
            <divider />
            <div class="p-field p-col-12 p-md-4 p-mt-3">
              <span class="p-float-label">
                <Textarea
                  v-model="expenditureModel.rejectReason"
                  v-validate="
                    expenditureModel.approved == false ? 'required' : ''
                  "
                  :autoResize="true"
                  rows="3"
                  v-bind:class="[
                    {
                      'p-invalid': errors.has('rejectReason'),
                    },
                    'form-control',
                  ]"
                  :id="'rejectReason'"
                  :name="'rejectReason'"
                />
                <label for="rejectReason">Razão de Não Ser Aprovada</label>
              </span>
              <small
                v-if="errors.has('rejectReason')"
                class="p-error"
                role="alert"
              >
                Razão de Não Ser Aprovada é obrigatório
              </small>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-3">
              <span
                class="p-float-label"
                style="top: -0.75rem; left: -1rem; font-size: 12px"
              >
                <label for="pats">Aprovada</label>
              </span>
              <InputSwitch
                v-model="expenditureModel.approved"
                :id="'approved'"
                :inputId="'approved'"
                :name="'approved'"
                style="'top: 3px;"
              />
            </div>
            <divider />
          </div>
          <div class="p-field p-grid p-col-12">
            <div class="p-field p-col-12">
              <FileUpload
                ref="uploadInput"
                mode="basic"
                name="files[]"
                chooseLabel="Adicionar Ficheiro"
                @select="fileSelected"
                v-if="
                  (expenditureModel.pat) &&
                  editable == true &&
                  inApprove == false
                "
              />
            </div>
            <small
              v-if="
                expenditureModel.filesError != undefined &&
                expenditureModel.filesError == true
              "
              class="p-error"
              role="alert"
            >
              Não foi adicionado nenhum ficheiro
            </small>
            <div class="p-col-12 p-md-3" v-if="expenditureId">
              <Button
                v-if="
                  expenditureModel.viewFileButton != undefined &&
                  expenditureModel.viewFileButton == true
                "
                label="Ver Ficheiros"
                icon="pi pi-eye"
                class="p-button-success"
                style="width: 100%"
                @click="getExpenditureFiles"
              />
              <Loading
                :active.sync="expenditureModel.looderFiles"
                :is-full-page="false"
              ></Loading>
              <div
                class="p-field p-col-12 p-md-12"
                v-for="file in expenditureModel.files"
                :key="file.referece"
              >
                <div v-if="file.type == 'pdf'" class="pdf-viewer">
                  <embed
                    :src="file.src"
                    type="application/pdf"
                    width="100%"
                    height="300px"
                  />
                </div>
                <div v-else style="text-align: center">
                  <ImagePreview
                    :src="file.src"
                    alt="Image"
                    width="250"
                    preview
                  />
                </div>
                <div class="p-col-12 p-text-center p-mt-1">
                  <Button
                    v-if="file.type == 'pdf'"
                    icon="pi pi-search"
                    class="p-button-rounded p-button-outlined p-button-raised"
                    aria:haspopup="true"
                    aria-controls="overlay_panel"
                    @click="file.fullView = true"
                  />
                  <Sidebar :visible.sync="file.fullView" position="full">
                    <div v-if="file.type == 'pdf'" class="pdf-fullview">
                      <embed
                        :src="file.src"
                        type="application/pdf"
                        width="100%"
                        height="500px"
                      />
                    </div>
                  </Sidebar>
                  <Button
                    v-if="
                      inApprove == false &&
                      editable == true &&
                      expenditureId &&
                      expenditureModel.files.length > 1
                    "
                    icon="pi pi-times"
                    class="p-button-rounded p-button-danger p-button-outlined p-button-raised p-ml-1"
                    @click="removeFile(file.reference)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          v-if="editable == true"
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="save"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import expenditureService from "../../services/expenditure.service";
import filesService from "../../services/files.service";
import interventionService from "../../services/intervention.service";
import fleetService from "../../services/fleet.service";
import { getOnlyDate } from "../../helpers/helpers";
import AppAutocomplete from "../elements/AppAutocomplete.vue";

export default {
  name: "ExpenditureForm",
  props: ["show", "expenditureId", "userId", "inApprove"],
  components: { Loading, AppAutocomplete },
  watch: {
    async expenditureId() {
      this.$validator.pause();
      this.cleanData();
      if (this.expenditureId != undefined) {
        this.loading = true;
        this.reset = false;
        await this.getInfo();
        this.reset = true;
        this.loading = false;
      }
      if (this.show == true) {
        this.$validator.resume();
      }
    },
  },
  data() {
    return {
      loading: false,
      pats: [],
      types: [],
      vehicles: [],
      referenceTo: 'pat',
      expenditureModel: {
        pat: null,
        date: null,
        filesError: false,
        car_registration: null
      },
      reset: true,
      editable: true,
      user: null,
      approved: false,
      typesConditions: {
        combustivel: 'JP25021752436,434931801',
        via_verde: 'JP25020873438,848101732',
      }
    };
  },
  async created() {
    if (this.inApprove == undefined) {
      this.inApprove = false;
    }
    this.types = await this.getItemsTypes();
    this.user = this.$store.state.auth.user;
  },
  computed: {
    patOptionLabel() {
      return (option) => {
        if (!option) return '';
        return `${option.id} | ${option.client_name || ''}`;
      };
    }
  },
  methods: {
    cleanData() {
      this.pats = [];
      this.referenceTo = 'pat';
      this.reset = true;
      this.editable = true;
      this.approved = false;
      this.expenditureModel = { filesError: false };
    },
    async getInfo() {
      return expenditureService
        .getExpenditure(this.expenditureId)
        .then((response) => {
          if (this.inApprove == true) {
            this.user = {
              id: response.userId,
              username: response.user,
              department: response.userDepartment,
            };
          }
          this.editable = !response.approved;
          this.referenceTo = "pat";
          this.expenditureModel = {
            id: response.pat,
            rejectReason: response.rejectReason,
            files: [],
            viewFileButton: true,
            approved: response.approved,
            date: new Date(response.day),
            installation: null,
            installationName: response.installationName,
            business: null,
            businessName: response.businessName,
            pat: response.pat,
            patName: response.patName,
            client_name: response.client_name,
            type_id: response.type_id,
            document_reference: response.document_reference,
            value: response.value,
            value_pay: response.value_pay,
            car_registration: response.car_registration,
            car_km: response.car_km,
            comments: response.comments,
            reference: response.reference,
          };
        });
    },
    getItemsTypes() {
      return expenditureService
        .getUserExpenditureItemsTypes()
        .then((response) => {
          response.forEach((type) => {
            type.reference = type.reference.replace(/ /g, "");
          });
          return response;
        });
    },

    async typeChanged() {
      if (!Object.values(this.typesConditions).includes(this.expenditureModel.type_id)) {
        return;
      }

      let date = getOnlyDate(this.expenditureModel.date);
      this.vehicles = await fleetService
        .searchVehiclesByUserDate(this.userId, date)
        .then((response) => {
          response.push({
            id: 0,
            registration: "00-00-00",
            model: "Viatura Própria",
          });
          return response;
        });
    },
    carRegistrationRequired() {
      if (
        this.expenditureModel.type_id != undefined &&
        (Object.values(this.typesConditions).includes(this.expenditureModel.type_id))
      ) {
        return "required";
      }

      return "";
    },
    carKmRequired() {
      if (
        this.expenditureModel.type_id != undefined &&
        this.expenditureModel.type_id.indexOf(this.typesConditions.combustivel) != -1
      ) {
        return "required";
      }
      return "";
    },
    cancel() {
      this.$validator.pause();
      this.cleanData();
      return this.$emit("cancel");
    },
    save() {
      this.$validator.validateAll().then((isValid) => {
        if (!this.expenditureId && this.$refs.uploadInput.files.length == 0) {
          this.expenditureModel.filesError = true;
          return (this.loading = false);
        } else {
          this.expenditureModel.filesError = false;
        }
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        let bodyParam = {
          user_id: this.user.id,
          date:
            this.expenditureModel.date instanceof Date
              ? getOnlyDate(this.expenditureModel.date)
              : this.expenditureModel.date,
          business_id: this.expenditureModel.business,
          installation_id: this.expenditureModel.installation,
          pat_id: this.expenditureModel.pat,
          type_id: this.expenditureModel.type_id,
          value: this.expenditureModel.value,
          value_pay: this.expenditureModel.value_pay,
          document_reference: this.expenditureModel.document_reference,
          comments: this.expenditureModel.comments
            ? this.expenditureModel.comments
            : "",
        };

        if (this.expenditureModel.car_registration) {
          bodyParam.car_registration = this.expenditureModel.car_registration;
        }
        if (this.expenditureModel.car_km) {
          bodyParam.car_km = this.expenditureModel.car_km;
        }
        if (this.expenditureId === undefined || this.expenditureId === null) {
          return this.createNew(bodyParam);
        } else if (this.editable == true) {
          return this.update(bodyParam);
        }
      });
    },
    fileSelected() {
      this.expenditureModel.filesError = false;
      this.$validator.validateAll();
    },
    createNew(params) {
      this.loading = true;
      return expenditureService
        .createExpenditure(params)
        .then((response) => {
          if (response.status >= 400) {
            this.loading = false;
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao Criar Despesa",
              detail: response.data.message,
              life: 5000,
            });
          }

          this.$toast.add({
            severity: "success",
            summary: "Despesa Criada",
            detail: "A despesa foi Criada com Sucesso",
            life: 5000,
          });
          return response.data;
        })
        .then((expend) => {
          this.myUploader(this.$refs.uploadInput.files[0], expend);
          return expend;
        })
        .then((res) => {
          this.loading = false;
          this.cleanData();
          return this.$emit("expenditureSaved", {
            expenditure: res,
          });
        });
    },
    update(params) {
      this.loading = true;
      expenditureService
        .updateExpenditure(this.expenditureId, params)
        .then((response) => {
          if (response.status >= 400) {
            this.loading = false;
            this.$toast.add({
              severity: "error",
              summary: "Erro ao atualizar",
              detail: response.data.message,
              life: 5000,
            });
            return false;
          }
          this.$toast.add({
            severity: "success",
            summary: "Despesa Atualizada",
            detail: "A despesa foi Atualizada com Sucesso",
            life: 5000,
          });
          return response.data;
        })
        .then((expend) => {
          if (expend == false) {
            return false;
          }
          if (
            this.inApprove == false &&
            this.$refs.uploadInput.files.length == 1
          ) {
            this.myUploader(this.$refs.uploadInput.files[0], expend);
          }
          return expend;
        })
        .then((res) => {
          this.loading = false;
          if (res == false) {
            return res;
          }
          return this.$emit("expenditureSaved", {
            expenditure: res,
          });
        })
        .then((resp) => {
          if (resp == false) {
            return false;
          }
          if (this.inApprove == false) {
            return false;
          }
          let param = {
            approved: this.expenditureModel.approved,
            rejectReason:
              this.expenditureModel.approved == false
                ? this.expenditureModel.rejectReason
                : "",
          };
          return expenditureService
            .approveExpenditure(this.expenditureId, param)
            .then((status) => {
              if (status == false || status.status >= 400) {
                this.loading = false;
                this.$toast.add({
                  severity: "error",
                  summary: "Erro ao Aprovar",
                  detail: status.data.message,
                  life: 5000,
                });
                return false;
              }

              this.$toast.add({
                severity: "success",
                summary: `Despesa ${
                  status.approved == 1 ? "Aprovada" : "Rejeitada"
                }`,
                detail: `A despesa foi ${
                  status.approved == 1 ? "Aprovada" : "Rejeitada"
                } com Sucesso`,
                life: 5000,
              });
              this.loading = false;
              return this.$emit("expenditureApproved", {
                approved: status.approved,
                reason: param.rejectReason,
              });
            });
        });
    },
    myUploader(file, expenditure) {
      let formData = new FormData();

      formData.append("file", file);
      formData.append("origin", "DS");
      formData.append("origin_reference", expenditure.reference);
      formData.append("resume", expenditure.description);

      return filesService.addFile(formData).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Ocorreu um erro ao inserir o ficheiro",
            life: 5000,
          });
        }

        return this.$toast.add({
          severity: "success",
          summary: "Ficheiro inserido",
          detail: "O Ficheiro inserido com sucesso",
          life: 5000,
        });
      });
    },
    removeFile(fileReference) {
      const fileAreYou = (fileAux) => {
        return fileAux.reference == fileReference;
      };

      this.$confirm.require({
        header: "Despesa - Apagar Ficheiro",
        message: "Tem a certeza que pretende apagar este ficheiro?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          let data = {
            reference: fileReference,
          };
          filesService.removeFile(data).then((response) => {
            if (!response) {
              return this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Ocorreu um erro ao eliminar o ficheiro",
                life: 5000,
              });
            }

            let fileIndex = this.expenditureModel.files.findIndex(fileAreYou);
            this.expenditureModel.files.splice(fileIndex, 1);

            return this.$toast.add({
              severity: "success",
              summary: "Ficheiro eliminado",
              detail: "O ficheiro foi eliminado com sucesso",
              life: 5000,
            });
          });
        },
        reject: () => {},
      });
    },
    getExpenditureFiles() {
      this.expenditureModel.files = [];
      this.expenditureModel.looderFiles = true;
      let data = {
        origin_reference: this.expenditureModel.reference,
      };
      filesService.getFileFromOriginReference(data).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Ocorreu um erro ao eliminar o ficheiro",
            life: 5000,
          });
        }
        response.forEach((file) => {
          file["fullView"] = false;
          if (file.type !== undefined && file.type == "pdf") {
            file.src = `data:application/${file.type};base64,${file.src}`;
          } else if (file.type !== undefined) {
            file.src = `data:image/${file.type};base64,${file.src}`;
          }

          this.expenditureModel.files.push(file);
        });
        this.expenditureModel.viewFileButton = false;
        this.expenditureModel.looderFiles = false;
      });
    },

    async fetchPats(search = '') {
      try {
        if (!this.expenditureModel.date || !this.userId) {
          return {};
        }

        const date = getOnlyDate(this.expenditureModel.date);
        const userId = this.userId
        const startDate = date
        const endDate = date

        if (!userId || !startDate || !endDate) {
          return [];
        }

        let pats = await interventionService.getInterventionsPat(
          userId,
          startDate,
          endDate,
          search
        );

        if (!Array.isArray(pats)) {
          pats = Object.values(pats);
        }

        return pats;
      } catch (error) {
        console.error('Error fetching PATs:', error);
        throw error;
      }
    },

    handlePatFetchError(error) {
      console.error('Error fetching PATs:', error);
      this.$toast.add({
        severity: "error",
        summary: "Erro ao carregar PATs",
        detail: "Ocorreu um erro ao carregar a lista de PATs",
        life: 5000,
      });
    },

    handlePatChange(patId) {
      if (patId) {
        this.expenditureModel.pat = patId;
      }
    },
    async dateChanged() {
      if (this.editable == false) {
        return;
      }

      if (this.reset == true) {
        this.expenditureModel.pat = null;
        this.expenditureModel.car_registration = null;
      }

      await this.typeChanged();
    },
  },
};
</script>
